import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { trackElement } from '@shared';
import { Education } from '@shared/models';

@Component({
  selector: 'mojo-candidate-education-card',
  templateUrl: './candidate-education-card.component.html',
  styleUrls: ['./candidate-education-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateEducationCardComponent {
  private readonly maxEducationsItems = 3;
  @Input() showCard = true;

  @Input()
  set educations(educations: Education[]) {
    this.allEducations = educations;
    this.expandable = educations && educations.length > this.maxEducationsItems;
    this.prepareDisplayEducations();
  }

  trackElement = trackElement;

  allEducations: Education[];
  displayedEducations: Education[];
  expandable = false;
  expanded = false;

  toggleCard(expanded: boolean) {
    this.expanded = expanded;
    this.prepareDisplayEducations();
  }

  prepareDisplayEducations() {
    if (this.expanded) {
      this.displayedEducations = this.allEducations;
    } else {
      this.displayedEducations = this.allEducations.slice(0, this.maxEducationsItems);
    }
  }
}
